module.exports = __webpack_public_path__ + "static/media/lungdis_help2211.007e3d1c.png";